import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events, ToastController } from 'ionic-angular';
import { FCM } from "cordova-plugin-fcm-with-dependecy-updated/ionic/v4";
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { EventNames } from '../lib/eventNames';
import { LoginPage } from '../pages/login';
import { LocalStorageService } from '../services/local-storage';
import { AccountHelper } from '../lib/accountHelper';
import { DataService } from '../services/data';
import { AlertMessager } from '../lib/alertMessager';
import { UserService } from '../services/user.service';
import { StaffPage } from '../pages/staff/staff';


@Component({
    selector: 'myapp',
    templateUrl: 'app.html'
})
export class MyApp {
    @ViewChild(Nav) nav: Nav;

    rootPage: any;
    accountHelper: AccountHelper = AccountHelper.instance();

    constructor(public platform: Platform, public statusBar: StatusBar, public events: Events, private alertMessager: AlertMessager,
        private toast: ToastController, private data: DataService, private fcm: FCM, public splashScreen: SplashScreen, 
        private localStorage: LocalStorageService, private userService: UserService) {
        this.initializeApp();

        events.subscribe(EventNames.userLoginRequired, () => {
            this.nav.setRoot(LoginPage);
        });

        this.refreshUserData();
    }

    refreshUserData() {
        if (!AccountHelper.instance().token) {
            setTimeout(() => {
                this.refreshUserData();
            }, 300000);
        } else {
            this.data.refreshUserData()
            .then(data => {
                this.localStorage.updateEntity('authtokens', data)
                .then(data => {
                    AccountHelper.instance().loadToken(data);
                    this.userService.getUser(data.id);
                });

                setTimeout(() => {
                    this.refreshUserData();
                }, 300000);
            }, error => {
                setTimeout(() => {
                    this.refreshUserData();
                }, 300000);
            });
        }
    }

    initializeApp() {
        this.platform.ready().then(() => {
            this.localStorage.getEntity('authtokens')
            .then(data => {
                this.statusBar.hide();
                this.statusBar.overlaysWebView(false);
                this.splashScreen.hide();

                if (data == null)
                    this.login();
                else {
                    AccountHelper.instance().loadToken(data);
                    this.userService.getUser(data.id);
                    
                    this.nav.setRoot(StaffPage);
                }
            }, error => {
                this.login();
            });

            if (this.platform.is('ios') || this.platform.is('android')) {
                this.events.subscribe(EventNames.userLoggedIn, this.setUpNotifications.bind(this));
            }
        });
    }

    setUpNotifications() {
        try {
            this.fcm.getToken().then(token => {

            });

            this.fcm.onNotification().subscribe(data => {
                console.log(JSON.stringify(data));
                if (data.wasTapped){
                    //Notification was received on device tray and tapped by the user.
                } else {
                    const toast = this.toast.create({
                        message: data.message,
                        duration: 3000,
                        position: 'bottom',
                    });

                    toast.present();
                }
            });

            this.fcm.onTokenRefresh().subscribe(token => {
            
            });
        } catch (error) {
            console.log('Notifications Error', error);
        }
    }

    logout() {
        this.data.logout()
		.then(data => {
            AccountHelper.instance().clearToken();
            this.localStorage.purge();
            this.nav.setRoot(LoginPage);
		}, error => this.alertMessager.showError('Logout Error', error));
    }

    login() {
        this.localStorage.purge();
        this.nav.setRoot(LoginPage);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts